import { emptyObj } from 'util/objects'
import { base } from './base'

export const selectProps = state => base(state).props || emptyObj
